import React from "react";
// import Button from "./Button"

export default function Modal({ closeModal, Title, Body, handleBtnClick, modalStyling, BtnAttr}) {
    const Close = () => (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L13 13M1 13L13 1L1 13Z" stroke="#C6C6CA" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
  return (
    <>
        <div
        className="w-full justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none"
        >
            <div className="relative my-6 bg-white w-3/4 sm:w-1/2 p-4 rounded">
                <div className={modalStyling}>
                    <div className="flex rounded-t mb-4">
                        <div className="text-base text-center leading-6 font-semibold">
                            <Title />
                        </div>
                        <button
                        className="p-1 ml-auto justify-items-end bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                        onClick={closeModal}
                        >
                            <Close />
                        </button>
                    </div>
                    <Body />
                </div>
            </div>
        </div>
        <div className="opacity-25 fixed inset-0 z-40 bg-black" onClick={closeModal}></div>
    </>
  );
}